var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.794,
    height: 10.937,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7698"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7654",
    d: "M1.674 0a1.672 1.672 0 00-.828.234A1.8 1.8 0 000 1.734v7.462a1.785 1.785 0 00.846 1.494 1.726 1.726 0 001.719.027l.018-.009 6.346-3.736a1.747 1.747 0 000-3.016v-.009L2.574.222 2.565.213a1.772 1.772 0 00-.891-.216zm.027 1.143a.6.6 0 01.306.09l6.337 3.718a.578.578 0 01.3.513.593.593 0 01-.3.522L2.007 9.713a.527.527 0 01-.567 0 .613.613 0 01-.288-.531V1.747a.612.612 0 01.288-.522.532.532 0 01.261-.081z",
    fill: "#5323f2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.324763bb5a16fc6ad1940264a7f94d68.svg";
export { ForwardRef as ReactComponent };